<template lang="pug">
  include /mixins
  +b.tt-space_mt--5.relative(style='min-height: 200px;')
    ui-loader(v-if='isLoad')

    +b.tt-order-previews.g-row--appearance_spaced.--justify_center
      +b.g-cell.g-cols--12.--6-md.--4-xl.--3-fhd(
        v-for='(orders, idx) in list'
      )
        +b.tt-order-preview
          +e.wrapper
            +e.head
              +e.title.P {{ _('Заказ №')}} {{ orders.index + 1 }}
              +e.count.P {{ _('Товаров:') }} #[span {{ getProductsCount(orders) }}]
            +e.products
              template(v-for='order in orders.orders')
                template(v-for='or in order')
                  template(v-for='product in or.props.simplified_data.items')
                    +e.product.A(
                      :href='fieldData("link", product)'
                      target='_blank'
                    )
                      +e.preview.IMG(
                        :src="fieldData('img', product) || '/static/img/rebranding/non.png'"
                        :alt='fieldData("image_alt", product)'
                        :title='fieldData("image_alt", product)'
                      )
              +e.info
                template(
                  v-for='payment in orders.payments[0]'
                )
                  +e.key.P(
                  ) {{ _("Способ оплаты") }}
                  +e.value.P {{ payment.props.gateway.title }}
              +e.info
                +e.key--bold.P(
                ) {{ _("Стоимость заказа") }}
                //- +e.value-wrap
                +e.value--bold.P #[span(v-html='getSplittedHtml(total(orders))')]

              +e.info--slim(v-if='Number(totalBonuses(orders))')
                +e.key--bold.--warning.P(
                ) {{ _("Будет списано бонусов") }}
                //- +e.value-wrap
                +e.value--bold.--warning.P #[span(v-html='getSplittedHtml(totalBonuses(orders))')]
              +b.line-h--light
              +e.info--slim(v-if='Number(totalBonuses(orders))')
                +e.key--bold.P(
                ) {{ _("Разом після списання бонусів") }}
                +e.value--bold.P #[span(v-html='getSplittedHtml(total(orders) - totalBonuses(orders))')]
              template(v-for='payment in orders.payments[0]')
                +e.info--slim()
                  +e.key--bold.P(
                  ) {{ _("К оплате по счету") }}
                  +e.value--bold.P #[span(v-html='getSplittedHtml((payment.props.amount), payment.props.currency_label)')]
                +b.tt-info-card--slim(v-if='payment.props.gateway.order_success_description')
                  +e.content
                    +e.icon
                      svg(width='24' height='24' viewbox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg')
                        path(d='M12 12V16.5M12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21Z' stroke='#1A1A1A' stroke-width='1.5' stroke-linecap='round')
                        circle(cx='12' cy='9' r='0.5' stroke='#1A1A1A')
                    +e.text-wrap
                      //- +e.title.P {{ _('Сумма к оплате зафиксирована на 3 дня при условии, что склад не изменит заказ.') }}
                      +e.text.t-content
                        renderer(
                          :result='`<div>${payment.props.gateway.order_success_description}</div>`'
                        )
              +e.cashback(
                v-if='totalCashback(orders) > 0'
              )
                +e.key--bold.P {{ _('Очікувана сума кешбеку') }}
                +e.cashback-value
                  +b.cashback-percent--only-icon
                    +e.icon.SVG(:title='_("cashback")' xmlns='http://www.w3.org/2000/svg', width='20', height='20', viewBox!='0 0 20 20', fill='none')
                      circle(cx='10' cy='10' r='10' fill='#FF7A00')
                      circle(cx='10' cy='10' r='8.5' fill='#FF7A00' stroke='white')
                      path(d='M10.5398 15C9.74432 15 9.00568 14.8816 8.32386 14.6448C7.65152 14.3989 7.06439 14.0528 6.5625 13.6066C6.07008 13.1603 5.68655 12.6321 5.41193 12.0219C5.13731 11.4117 5 10.7377 5 10C5 9.2623 5.13731 8.58834 5.41193 7.97814C5.68655 7.36794 6.07008 6.83971 6.5625 6.39344C7.06439 5.94718 7.65152 5.60565 8.32386 5.36885C9.00568 5.12295 9.74432 5 10.5398 5C11.5152 5 12.3769 5.16393 13.125 5.4918C13.8826 5.81967 14.5076 6.29326 15 6.91257L12.8835 8.72951C12.59 8.37432 12.2633 8.10109 11.9034 7.90984C11.553 7.70947 11.1553 7.60929 10.7102 7.60929C10.3598 7.60929 10.0426 7.66393 9.75852 7.77322C9.47443 7.88251 9.22822 8.04189 9.01989 8.25137C8.82102 8.46084 8.66477 8.71585 8.55114 9.01639C8.4375 9.30783 8.38068 9.6357 8.38068 10C8.38068 10.3643 8.4375 10.6967 8.55114 10.9973C8.66477 11.2887 8.82102 11.5392 9.01989 11.7486C9.22822 11.9581 9.47443 12.1175 9.75852 12.2268C10.0426 12.3361 10.3598 12.3907 10.7102 12.3907C11.1553 12.3907 11.553 12.2951 11.9034 12.1038C12.2633 11.9035 12.59 11.6257 12.8835 11.2705L15 13.0874C14.5076 13.6976 13.8826 14.1712 13.125 14.5082C12.3769 14.8361 11.5152 15 10.5398 15Z' fill='white')
                  +e.cashback-data.P(
                    style='line-height: 1;'
                    v-html='getSplittedHtml(totalCashback(orders))'
                  )
              +e.btn
                template(
                  v-if="pathOr(null, ['props', 'status', 'order_status_group', 'value'], orders[0]) != 'cancelled'"
                  v-for='payment in orders.payments[0]'
                )
                  +b.tt-button.A(
                    v-for='text in payment.props.gateway.status_texts'
                    :href='payment.props.paid_url'
                    v-if='payment.props.paid_url && payment.props.status == text.props.status'
                    target='_blank'
                  )
                    +e.title.SPAN {{ text.props.text }}
                  template(
                    v-if="payment.props.requisites && !(payment.props.gateway.service == $options.PREPAYMENT_ACCOUNT_PAYMENT_SERVICE && successStatus(payment.props.status))"
                  )
                    +b.tt-button.A(
                      @click.prevent='openModal(orders.payments[0])'
                    )
                      +e.title.SPAN {{ _('Реквизиты для оплаты') }}
      
</template>
<script>
import { pathOr } from 'ramda'
import {
  ordersAnonymousList,
  // exportResource,
} from '@api/staff.service'

import Renderer from '@app/List/Renderer'

import {
  groupByOrNull,
  pathGetterArray,
} from '@utils/helpers'

const lang = window.language

const WAITING_PAYMENT_STATUS = 'waiting_for_payment'
const PAID_PAYMENT_STATUS = 'paid'
const HOLD_PAYMENT_STATUS = 'hold'
const ERROR_PAYMENT_STATUS = 'error'

const NOVAPAY_PAYMENT_SERVICE = 'novapay'
const PREPAYMENT_ACCOUNT_PAYMENT_SERVICE = 'prepayment_account'

const NAL_PLAT_UPON_RECEIPT = 'nal_plat_upon_receipt'
const CASH_UPON_RECEIPT = 'cash_upon_receipt'
const NON_CASH_UPON_RECEIPT = 'non_cash_upon_receipt'

const AFTER_PAYMENT = [NAL_PLAT_UPON_RECEIPT, CASH_UPON_RECEIPT, NON_CASH_UPON_RECEIPT]

const SHOW_PAYMENT_LINK_STATUSES = [WAITING_PAYMENT_STATUS, ERROR_PAYMENT_STATUS]
const SUCCESS_PAYMENT_STATUSES = [PAID_PAYMENT_STATUS, HOLD_PAYMENT_STATUS]

export default {
  name: 'order-state-loader',
  props: {
    national_currency_symbol: {
      type: String,
      required: true,
    },
    national_currency: {
      type: String,
      required: true,
    },
    current_site_currency: {
      type: String,
      required: true,
    },
    single_state: {
      type: String,
      required: false,
    },
  },
  components: {
    Renderer,
  },
  ordersAnonymousList,
  PAID_PAYMENT_STATUS,
  NOVAPAY_PAYMENT_SERVICE,
  PREPAYMENT_ACCOUNT_PAYMENT_SERVICE,
  AFTER_PAYMENT,
  data() {
    return {
      cashbackUrl: window.cashback_rules,
      state: null,
      isLoad: true,
      parameters: {
        ordering: '-created_at',
        uuids: '',
      },
      list: [],
      fields: {
        id: ['id'],
        created_at: ['props', 'created_at'],
        external_start_date: ['props', 'external_start_date'],
        status: ['props', 'status', 'title'],
        status_id: ['props', 'status', 'order_status_group', 'value'],
        amount: ['props', 'payments', 0, 'props', 'amount'],
        payment_status: ['props', 'payment_status', 'display'],
        link: ['detail', 'url'],
        img: ['detail', 'img', 'catalog_preview'],
        image_alt: ['detail', 'product', 'title'],
        orders_path: ['props', 'orders'],
        orders: {
          waybill_code: ['props', 'waybill_code'],
          delivery_payment_type: ['props', 'shipping_service', 'props', 'price_description'],
          delivery_type_caption: ['props', 'shipping_service', 'caption'],
          delivery_warehouse: ['props', 'warehouse', 'caption'],
          delivery_street: ['props', 'street', 'props', 'description'],
          delivery_street_type: ['props', 'street', 'props', 'streets_type'],
          delivery_house: ['props', 'house'],
          delivery_building: ['props', 'building'],
          delivery_apartment: ['props', 'apartment'],
          delivery_city: ['props', 'city', 'props', lang === 'ru' ? 'description_ru' : 'description'],
          delivery_city_type: ['props', 'city', 'props', lang === 'ru' ? 'settlement_type_description_ru' : 'settlement_type_description'],
          warehouse_info: ['props', 'warehouse'],
          first_name: ['props', 'first_name'],
          last_name: ['props', 'last_name'],
          phone: ['props', 'phone'],
          email: ['props', 'email'],
          uuid: ['props', 'external_id'],
          number: ['props', 'order_number'],
          created_at: ['props', 'created_at'],
          external_start_date: ['props', 'external_start_date'],
          order_item_status: ['props', 'status', 'display'],
          shipping_payment_amount: ['props', 'shipping_service', 'props', 'title'],
          total: ['props', 'total_price'],
          currency: ['props', 'currency_label'],
          bonus_sum: ['props', 'bonus_sum'],
          simplified_data: {
            preview: ['detail', 'img', 'catalog_preview'],
            caption: ['detail', 'product', 'title'],
            is_active: ['detail', 'is_active'],
            weight: ['detail', 'weight', 'props', 'name'],
            price: ['price'],
            quantity: ['quantity'],
            discount_value: ['discount_value'],
            full_price: ['sum'],
            link: ['detail', 'url'],
            brand_name: ['brand_name'],
            item_name: ['item_name'],
          },
        },
      },
      lang: window.language,
    }
  },
  computed: {
    fieldData() {
      return function (val, item) {
        return pathOr(null, this.fields[val], item)
      }
    },
    total() {
      return function (val) {
        const o = val.orders.reduce((acc0, order0) => {
          const r = order0.reduce((acc, order) => acc + order.props.total_price, 0)
          acc0 += r
          return acc0
        }, 0)
        return o
      }
      //  return val.props.orders.reduce((acc, x) => acc + x.props.total_price, 0)
    },
    totalCashback() {
      return function (val) {
        const o = val.orders.reduce((acc0, order0) => {
          const r = order0.reduce((acc, order) => acc + order.props.bonus_cashback_amount, 0)
          acc0 += r
          return acc0
        }, 0)
        return o
      }
    },
    totalBonuses() {
      return function (val) {
        const o = val.orders.reduce((acc0, order0) => {
          const r = order0.reduce((acc, order) => acc + order.props.bonus_sum, 0)
          acc0 += r
          return acc0
        }, 0)
        return o
      }
    },
  },
  mounted() {
    const state = new URLSearchParams(window.location.search).get('_state')
    if (state) {
      this.state = JSON.parse(atob(state))
      this.parameters.uuids = this.state.join(',')
      console.log(this.state, this.parameters, '>>>>>>>>>>>');
    }
    if (this.single_state) {
      this.parameters.uuids = [this.single_state]
    }
    this.getList()
  },
  methods: {
    pathOr,
    successStatus(status) {
      return SUCCESS_PAYMENT_STATUSES.includes(status)
    },
    getProductsCount(item) {
      const o = item.orders.reduce((acc0, order0) => {
        const r = order0.reduce((acc, order) => acc + order.props.simplified_data.items.length + order.props.simplified_data.gifts.length, 0)
        acc0 += r
        return acc0
      }, 0)
      return o
    },
    async getList() {
      const { data: { items } } = (await ordersAnonymousList.execute({ filters: this.parameters }))
      const groups = groupByOrNull(items, pathGetterArray(['props', 'payments'], null), pathGetterArray(['id'], null))
      Object.keys(groups).forEach((key, index) => {
        groups[key].orders = groups[key].map(e => e.props.orders)
        groups[key].payments = groups[key].map(e => e.props.payments)
        groups[key].index = index
      })
      console.log(groups);
      this.list = groups
      this.isLoad = false
    },
    getIdsList(orders) {
      return orders.filter(e => e.props.order_number).map(e => !!e.props.order_number && e.props.order_number).join(', ')
    },
    containStatus(status) {
      return SHOW_PAYMENT_LINK_STATUSES.includes(status)
    },
    openModal(payments) {
      this.$modal.show(
        () => import('@app/Order/Requisites'),
        {
          payments,
        }, {
          height: 'auto',
          adaptive: true,
          scrollable: true,
        }
      )
    },
  },
}
</script>
